module.exports = __webpack_public_path__ + "img/warning.3be4ea5a.png";